import { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionTopics from './components/SectionTopics';
import SectionAbout from './components/SectionAbout';
import SectionCards from './components/SectionCards';
import SectionRanking from './components/SectionRanking';
import SectionUpdates from './components/SectionUpdates';
import SectionFeatures from './components/SectionFeatures';
import SectionIndex from './components/SectionIndex';
import SectionComments from './components/SectionComments';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionFaq from './components/SectionFaq';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="relative min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <SectionCarousel />
        <SectionContact />
        <SectionTopics />
        <SectionAbout />
        <SectionCards />
        <SectionRanking />
        <SectionUpdates />
        <SectionFeatures />
        <SectionIndex />
        <SectionComments />
        <SectionMedia />
        <SectionApp />
        <SectionFaq />
      </main>
      <Footer />
    </div>
  );
}